var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 52,
    viewBox: "0 0 66 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7301 4.53665L59.2871 14.547C60.1908 15.0096 60.2049 16.3248 59.3114 16.8075L33.9114 30.531C32.4952 31.2962 30.8054 31.3152 29.3731 30.5821L13.4255 22.4191C11.4827 21.6201 9.31033 23.0794 9.31033 25.2775C9.31033 27.0448 10.2857 28.6604 11.8298 29.4508L27.8185 37.6347C28.7945 36.6173 30.1535 35.9863 31.6565 35.9863C33.1165 35.9863 34.4406 36.5817 35.4099 37.5483L55.3244 26.7887C55.2699 26.4741 55.2414 26.1502 55.2414 25.8196C55.2414 22.7782 57.6498 20.3128 60.6207 20.3128C63.5916 20.3128 66 22.7782 66 25.8196C66 28.861 63.5916 31.3264 60.6207 31.3264C59.1681 31.3264 57.8499 30.737 56.882 29.779L36.9563 40.5447C37.0085 40.8528 37.0358 41.1697 37.0358 41.4931C37.0358 44.5345 34.6274 47 31.6565 47C28.6856 47 26.2772 44.5345 26.2772 41.4931C26.2772 41.2119 26.2978 40.9355 26.3376 40.6655L10.1173 32.3631C7.59394 31.0715 6 28.4313 6 25.5432V23.9345C6 21.735 7.18916 19.7161 9.08939 18.6895L35.1918 4.5877C36.608 3.82252 38.2978 3.80351 39.7301 4.53665ZM31.6565 43.6111C32.7991 43.6111 33.7254 42.6629 33.7254 41.4931C33.7254 40.3234 32.7991 39.3751 31.6565 39.3751C30.5139 39.3751 29.5876 40.3234 29.5876 41.4931C29.5876 42.6629 30.5139 43.6111 31.6565 43.6111ZM62.6897 25.8196C62.6897 26.9894 61.7634 27.9376 60.6207 27.9376C59.4781 27.9376 58.5518 26.9894 58.5518 25.8196C58.5518 24.6498 59.4781 23.7016 60.6207 23.7016C61.7634 23.7016 62.6897 24.6498 62.6897 25.8196Z",
    fill: "#101523"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.797fd77ae6230c5fdbbecfd5f15439b9.svg";
export { ForwardRef as ReactComponent };